import React, { memo, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { ReactComponent as UserIcon } from 'shared/img/user.svg'

import { getCurrencySymbol } from 'shared/constants/currencies/getCurrencySymbol'

import { selectUserCurrency } from 'features/auth/selectors'

import { PragmaticDGABlackJack, PragmaticDGAGame } from 'components/slots/PragmaticDGA/hooks'

import './MainInfo.scss'

const b = block('pragmatic-dga-main-info')

type MainInfoProps = PragmaticDGAGame

export const MainInfo = memo((props: MainInfoProps) => {
  const { tableType, tableLimits, totalSeatedPlayers } = props

  const currency = useSelector(selectUserCurrency, shallowEqual)
  const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency])

  const content = useMemo(() => {
    switch (tableType) {
      case 'BLACKJACK': {
        const { availableSeats } = props as PragmaticDGABlackJack
        return (
          <>
            <div className={b('limits')}>
              <span className={b('text')}>
                {currencySymbol}
                {tableLimits.minBet} - {currencySymbol}
                {tableLimits.maxBet}
              </span>
            </div>
            <div className={b('users-count')}>
              <UserIcon className={b('user-icon')} />
              <span className={b('text')}>{availableSeats}/7</span>
            </div>
          </>
        )
      }

      default: {
        return (
          <>
            <div className={b('limits')}>
              <span className={b('text')}>
                {currencySymbol}
                {tableLimits.minBet} - {currencySymbol}
                {tableLimits.maxBet}
              </span>
            </div>
            <div className={b('users-count')}>
              <UserIcon className={b('user-icon')} />
              <span className={b('text')}>{totalSeatedPlayers}</span>
            </div>
          </>
        )
      }
    }
  }, [currencySymbol, props, tableLimits.maxBet, tableLimits.minBet, tableType, totalSeatedPlayers])

  return <div className={b()}>{content}</div>
})
